import { Checkbox as MuiCheckbox, useTheme } from '@mui/material';
import { MdCheck } from '@teamworksdev/icons';
import { cn } from '../utils';

/**
 * The design's checkbox: a 16px / 3px-radius box, filled `info.main` with a
 * white check when on, white with a grey border when off. MUI's stock icons
 * are a different size and corner radius, so both states are supplied as
 * icons rather than restyled.
 */
export function Checkbox({
  checked,
  disabled,
  onBlur,
  onChange,
}: {
  checked: boolean;
  disabled: boolean;
  onBlur: () => void;
  onChange: (checked: boolean) => void;
}) {
  const {
    palette: { common, info, greyscaleLight },
  } = useTheme();
  const boxClass = 'flex size-4 items-center justify-center rounded-[3px]';

  return (
    <MuiCheckbox
      size="small"
      // Body text is 20px tall, so 2px puts the 16px box's top on the title's.
      className="p-0 pt-0.5"
      disableRipple
      checked={checked}
      disabled={disabled}
      onBlur={onBlur}
      onChange={(e) => onChange(e.target.checked)}
      icon={
        <span
          className={cn(boxClass, 'border border-solid')}
          style={{
            backgroundColor: disabled ? greyscaleLight[100] : common.white,
            borderColor: disabled ? greyscaleLight[300] : greyscaleLight[500],
          }}
        />
      }
      checkedIcon={
        <span
          className={boxClass}
          style={{
            backgroundColor: disabled ? greyscaleLight[300] : info.main,
          }}
        >
          <MdCheck size={12} color={common.white} />
        </span>
      }
    />
  );
}
